<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 搜索区 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="推广短码">
                <a-input v-model="queryParam.salesCode" allow-clear placeholder="请输入推广短码"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="销售姓名">
                <a-input v-model="queryParam.salesName" allow-clear placeholder="请输入销售姓名"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="销售手机号">
                <a-input v-model="queryParam.salesPhone" allow-clear placeholder="请输入手机号"/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParam.status" allow-clear placeholder="请选择状态">
                  <a-select-option :value="1">启用</a-select-option>
                  <a-select-option :value="0">停用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span :style="advanced && { float: 'right', overflow: 'hidden' } || {}" class="table-page-search-submitButtons">
                <a-button type="primary" @click="handleQuery"><a-icon type="search"/>查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo"/>重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>

      <!-- 操作区 -->
      <div class="table-operations">
        <a-button v-hasPermi="['biz:promotion:sales:add']" type="primary" @click="$refs.createForm.handleAdd()">
          <a-icon type="plus"/>新增销售
        </a-button>
        <a-button v-hasPermi="['biz:promotion:sales:edit']" :disabled="single" type="primary" @click="$refs.createForm.handleUpdate(undefined, ids)">
          <a-icon type="edit"/>修改
        </a-button>
        <a-button v-hasPermi="['biz:promotion:sales:remove']" :disabled="multiple" type="danger" @click="handleDelete">
          <a-icon type="delete"/>删除
        </a-button>
        <a-button v-hasPermi="['biz:promotion:sales:list']" @click="goStats">
          <a-icon type="fund"/>查看推广统计
        </a-button>
        <table-setting
          v-model="columns"
          :refresh-loading="loading"
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          @refresh="getList"
        />
      </div>

      <create-form ref="createForm" @ok="getList"/>
      <qr-code-modal ref="qrCodeModal"/>

      <a-table
        :bordered="tableBordered"
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="false"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :scroll="{ x: 1500 }"
        :size="tableSize"
        rowKey="id"
      >
        <span slot="status" slot-scope="text, record">
          <a-tag v-if="record.status === 1" color="green">启用</a-tag>
          <a-tag v-else-if="record.status === 0" color="red">停用</a-tag>
          <span v-else>-</span>
        </span>
        <span slot="salesCode" slot-scope="text, record">
          <a-tooltip :title="`点击复制 ${record.salesCode}`">
            <a class="copyable" @click="copyText(record.salesCode, '推广短码已复制')">{{ record.salesCode }}</a>
          </a-tooltip>
        </span>
        <span slot="stat30d" slot-scope="text, record">
          <a-tooltip placement="top" title="最近 30 天累计">
            <span>
              <span class="stat-pill stat-pill--scan">扫码 {{ record.scanPv || 0 }} / {{ record.scanUv || 0 }}</span>
              <span class="stat-pill stat-pill--click">点击 {{ record.downloadClick || 0 }}</span>
            </span>
          </a-tooltip>
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="updateTime" slot-scope="text, record">
          {{ parseTime(record.updateTime) }}
        </span>
        <template slot="operation" slot-scope="text, record">
          <a v-hasPermi="['biz:promotion:sales:list']" @click="$refs.qrCodeModal.open(record)">
            <a-icon type="qrcode"/>下载二维码
          </a>
          <a-divider v-hasPermi="['biz:promotion:stats:list']" type="vertical"/>
          <a v-hasPermi="['biz:promotion:stats:list']" @click="goStats(record)">
            <a-icon type="fund"/>统计
          </a>
          <a-divider v-hasPermi="['biz:promotion:sales:edit']" type="vertical"/>
          <a v-hasPermi="['biz:promotion:sales:edit']" @click="$refs.createForm.handleUpdate(record, undefined)">
            <a-icon type="edit"/>修改
          </a>
          <a-divider v-hasPermi="['biz:promotion:sales:remove']" type="vertical"/>
          <a v-hasPermi="['biz:promotion:sales:remove']" @click="handleDelete(record)">
            <a-icon type="delete"/>删除
          </a>
        </template>
      </a-table>

      <a-pagination
        :current="queryParam.pageNum"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        :total="total"
        class="ant-table-pagination"
        show-quick-jumper
        show-size-changer
        @change="changeSize"
        @showSizeChange="onShowSizeChange"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { delPromotionSales, pagePromotionSales } from '@/api/promotion/sales'
import CreateForm from './modules/CreateForm'
import QrCodeModal from './modules/QrCodeModal'
import { tableMixin } from '@/store/table-mixin'
import { parseTime } from '@/utils/ruoyi'

export default {
  name: 'PromotionSales',
  components: { CreateForm, QrCodeModal },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: this.buildQueryParam(),
      columns: [
        { title: '推广短码', dataIndex: 'salesCode', width: 130, align: 'center', fixed: 'left', scopedSlots: { customRender: 'salesCode' } },
        { title: '销售姓名', dataIndex: 'salesName', width: 120, align: 'center' },
        { title: '手机号', dataIndex: 'salesPhone', width: 130, align: 'center' },
        { title: '状态', dataIndex: 'status', width: 80, align: 'center', scopedSlots: { customRender: 'status' } },
        { title: '近30天统计', dataIndex: 'stat30d', width: 280, align: 'center', scopedSlots: { customRender: 'stat30d' } },
        { title: '创建时间', dataIndex: 'createTime', width: 160, align: 'center', scopedSlots: { customRender: 'createTime' } },
        { title: '更新时间', dataIndex: 'updateTime', width: 160, align: 'center', scopedSlots: { customRender: 'updateTime' } },
        { title: '备注', dataIndex: 'remark', width: 160, ellipsis: true, align: 'center' },
        { title: '操作', dataIndex: 'operation', width: 320, fixed: 'right', align: 'center', scopedSlots: { customRender: 'operation' } }
      ]
    }
  },
  created() {
    this.getList()
  },
  methods: {
    parseTime,
    buildQueryParam() {
      return {
        salesCode: undefined,
        salesName: undefined,
        salesPhone: undefined,
        status: undefined,
        pageNum: 1,
        pageSize: 10
      }
    },
    getList() {
      this.loading = true
      pagePromotionSales(this.queryParam).then(response => {
        this.list = response.data.records || []
        this.total = response.data.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery() {
      this.queryParam = this.buildQueryParam()
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleDelete(row) {
      const that = this
      const ids = row && row.id ? [row.id] : this.ids
      this.$confirm({
        title: '确认删除所选中销售推广记录?',
        content: '当前选中ID为' + ids.join(',') + '；删除后历史埋点日志仍保留，仅该销售不再出现在列表中',
        onOk() {
          return delPromotionSales(ids.map(id => ({ id }))).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        }
      })
    },
    copyText(text, msg) {
      if (!text) return
      this.$copyText(text).then(() => {
        this.$message.success(msg)
      }).catch(() => {
        this.$warning({ title: '请手动复制', content: text })
      })
    },
    goStats(record) {
      const query = record && record.salesCode ? { salesCode: record.salesCode, salesName: record.salesName } : {}
      this.$router.push({ path: '/promotion/stats', query })
    }
  }
}
</script>

<style scoped>
.copyable {
  color: #1890ff;
  font-family: SFMono-Regular, Consolas, monospace;
  cursor: pointer;
}
.stat-pill {
  display: inline-block;
  margin: 0 4px;
  padding: 1px 8px;
  font-size: 12px;
  line-height: 20px;
  border-radius: 10px;
  white-space: nowrap;
}
.stat-pill--scan {
  background: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}
.stat-pill--click {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}
</style>
